import { createTranslations } from '@npco/utils-translations'

export const noBillersFoundInfoTranslations = createTranslations({
  info: 'No Billers found. Please check the Biller Code on your bill and try again.',
})
